export class SessionValidationFailedException extends Error {
    public constructor(public readonly source: Error) {
        super(source.message)
        Object.setPrototypeOf(this, SessionValidationFailedException.prototype)
    }
}
